import axios from "axios";
import {authHeader} from "@/helpers/auth-header";

export const apiKeyService = {
    createKey(owner) {
        return new Promise(((resolve, reject) => {
            axios({
                method: "post",
                url: "/api/apikey?owner="+owner,
                headers: authHeader(),
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        }));
    },
    getKeys() {
        return new Promise(((resolve, reject) => {
            axios({
                method: "get",
                url: "/api/apikey",
                headers: authHeader(),
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        }));
    },
    deleteKey(key) {
        return new Promise(((resolve, reject) => {
            axios({
                method: "delete",
                url: "/api/apikey",
                headers: {'Content-Type': 'application/json','Authorization': 'Bearer ' + localStorage.getItem("token")},
                data: '"'+key+'"'
            }).then(function () {
                resolve();
            }).catch(function (error) {
                reject(error);
            });
        }));
    }
}